import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { myConstants } from '../../shares/Constants'

export const EmailApi = createApi({
  reducerPath: 'EmailApi',
  tagTypes: ['Emails'],
  baseQuery: fetchBaseQuery({
    baseUrl: myConstants.baseURL,
    prepareHeaders: (headers, { getState }) => 
    {
      const token = getState().auth.token;
      if (token) headers.set('Authorization', `token ${token}`);
      return headers;
    },
  }),
  endpoints: (build) => ({

    fetchEmails: 
      build.query({
        query: ({ year, status }) => ({
          url: myConstants.endpoints.api.base + year + myConstants.endpoints.actions.email.list
            + (status ? `?status=${encodeURIComponent(status)}` : ''),
          method: 'GET',
        }),
        providesTags: (result, error, { year }) => [{ type: 'Emails', id: year }],
      }),

    fetchEmailDetail: 
      build.query({
        query: ({ year, emailId }) => ({
          url: myConstants.endpoints.api.base + year + '/email/' + emailId + '/',
          method: 'GET',
        }),
        providesTags: (result, error, { emailId }) => [{ type: 'Emails', id: emailId }],
      }),

    updateEmail: 
      build.mutation({
        query: ({ year, emailId, ...data }) => ({
          url: myConstants.endpoints.api.base + year + '/email/' + emailId + '/' + myConstants.endpoints.actions.email.update,
          method: 'PATCH',
          body: data,
        }),
        invalidatesTags: (result, error, { year, emailId }) => [
          { type: 'Emails', id: year },
          { type: 'Emails', id: emailId },
        ],
      }),

    replyToEmail: 
      build.mutation({
        query: ({ year, emailId, body }) => ({
          url: myConstants.endpoints.api.base + year + '/email/' + emailId + '/' + myConstants.endpoints.actions.email.reply,
          method: 'POST',
          body: { body },
        }),
        invalidatesTags: (result, error, { year, emailId }) => [
          { type: 'Emails', id: year },
          { type: 'Emails', id: emailId },
        ],
      }),

  }),
});

export const {
  useFetchEmailsQuery,
  useFetchEmailDetailQuery,
  useUpdateEmailMutation,
  useReplyToEmailMutation,
} = EmailApi;
